import { detachModuleDistance, detachShelfDistance, magnetDistance, magnetRackShift } from '@/Constants/common';
import { attachShelf, detachShelf } from '@/Engine/eventHandlers/lib/attachShelf';
import { detachRack } from '@/Engine/eventHandlers/lib/attachRack';
import { Line3, Vector3 } from 'three';
import { smartShelfCollision } from '@/Engine/eventHandlers/lib/shelfDocking';
import { $ } from '@/Engine/state';
import { Shelf } from '@/Interfaces/common';

export function checkShelfDocking(shelf: Shelf, localLine: Line3) {
    if (!shelf) return false;
    if (!shelf.rackModule) return false;
    if (!shelf.rackModule.railGroup) return false;
    if (!$.selectionBox.side) return false;
    //Только если на рельсе один модуль
    if (shelf.rackModule.railGroup.racks.length < 2) return false;
    //Если в модуле больше одной полки, то выносим ее и создаем новый модуль
    if (shelf.rackModule.shelves.length > 1) {
        if (Math.abs(localLine.start.x - localLine.end.x) > detachShelfDistance) {
            detachShelf(shelf);
        }
        return;
    }
    // Иначе разрешаем двигать только влево и вправо
    else {
        // const success = selectionBox.setPositionDelta(line, true);
        // Отстыковка если перенесли полку больше чем на
        const leftDistance = shelf.rackModule.nearestLeftModuleDistance;
        const rightDistance = shelf.rackModule.nearestRightModuleDistance;

        if (leftDistance === null && rightDistance && rightDistance > detachModuleDistance) {
            detachRack(shelf);
        }
        if (rightDistance === null && leftDistance && leftDistance > detachModuleDistance) {
            detachRack(shelf);
        }

        let leftMagnetFlag = false;
        let rightMagnetFlag = false;
        // Если между стойками маленькое расстояние, то примагничиваем
        const racks = shelf.rackModule.railGroup.racks;
        const rackOffset = new Vector3(-magnetRackShift, 0,0);
        let magnetFlag = false;
        for (const rack of racks) {
            // shelf.rackModule.railGroup.racks.forEach((rack)=>{
            if (shelf.rackModule?.uuid === rack.uuid) continue;
            if (rack.uuid === 'temp') continue;
            const oldPosition = shelf.position.clone();
            // Слева изнутри
            if (shelf.rackModule?.upLeftPoint.distanceTo(rack.upLeftPoint) < magnetDistance) {
                const delta = shelf.rackModule?.upLeftPoint.clone().sub(rack.upLeftPoint);
                shelf.position = shelf.position.clone().sub(delta);
                if (smartShelfCollision(shelf, $.selectionBox.side)) {
                    shelf.position = oldPosition;
                } else {
                    leftMagnetFlag = true;
                    magnetFlag = true;
                }
            }
            // Спарава изнутри
            if (shelf.rackModule?.upRightPoint.distanceTo(rack.upRightPoint) < magnetDistance) {
                const delta = shelf.rackModule?.upRightPoint.clone().sub(rack.upRightPoint);
                if (!leftMagnetFlag)
                    shelf.position = shelf.position.clone().sub(delta);
                if (smartShelfCollision(shelf, $.selectionBox.side)) {
                    shelf.position = oldPosition;
                } else {
                    rightMagnetFlag = true;
                    magnetFlag = true;
                }
            } else
                // Стыковка к модулю слева снаружи
            if (shelf.rackModule?.upLeftPoint.distanceTo(rack.upRightPoint) < magnetDistance) {
                const delta = shelf.rackModule?.upLeftPoint.clone()
                    .sub(rack.upRightPoint)
                    .add(new Vector3(magnetRackShift, 0,0));
                shelf.position = shelf.position.clone().sub(delta);
                if (smartShelfCollision(shelf, $.selectionBox.side)) {
                    shelf.position = oldPosition;
                } else
                    magnetFlag = true;
                // break;
            } else
                // Стыковка к модулю справа снаружи
            if (shelf.rackModule?.upRightPoint.distanceTo(rack.upLeftPoint.clone().sub(rackOffset)) < magnetDistance) {
                const delta = shelf.rackModule?.upRightPoint.clone()
                    .sub(rack.upLeftPoint)
                    .add(new Vector3(-magnetRackShift, 0,0));
                shelf.position = shelf.position.clone().sub(delta);
                if (smartShelfCollision(shelf, $.selectionBox.side)) {
                    shelf.position = oldPosition;
                } else
                    magnetFlag = true;
                // break;
            }

            // если слева и справа рейки совпали то надо перенести полку в другой модуль
            // модуль полки удалить
            if (leftMagnetFlag && rightMagnetFlag &&
                shelf.rackModule.width === rack.width
            ) {
                return attachShelf(shelf, rack);
            }

        }

        // if (!success) return false;
        // if (magnetFlag) {
        //     $.bigDistanceFlag = false;
        //     return false;
        // }

        return true;
    }
}
